export enum MediaType{
    IMAGE="image",
    VIDEO="video",
    PDF="pdf"
}

export enum ReservedImageKey {
    HERO_IMAGE = "__hero",
    TEXTURE_IMAGE = "__texture"
}